//Challenge Modal Component - challenge-modal.component.tsx
import {
  Component,
  OnInit,
  OnDestroy,
  signal,
  inject,
  input,
  output
} from '@angular/core';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { WindowProvider } from '../../../../core/window.provider.js';
import { Coinflow3DSCheckoutError } from '../../common.js';
import { LoadingComponent } from '@gains-com/ui-angular';

@Component({
  selector: 'app-coinflow-challenge-modal',
  standalone: true,
  imports: [LoadingComponent],
  templateUrl: './coinflow-challenge-modal.component.html',
  styleUrls: ['./coinflow-challenge-modal.component.scss'],
})
export class ChallengeModalComponent implements OnInit, OnDestroy {
  private readonly _sanitizer = inject(DomSanitizer);
  private readonly _window = inject(WindowProvider);

  readonly _3dsData = input.required<Coinflow3DSCheckoutError>();

  readonly closeModal = output<void>();
  readonly challengeComplete = output<string>();

  iframeSrc = signal<SafeResourceUrl | null>(null);

  private readonly _handleMessage = (event: MessageEvent<string>) => {
    if (event.data === 'challenge_success') {
      this.challengeComplete.emit(this._3dsData().transactionId!);
    }
  };

  ngOnInit(): void {
    this._window.addEventListener('message', this._handleMessage);

    this.iframeSrc.set(
      this._sanitizer.bypassSecurityTrustResourceUrl(this.getIframeSrc())
    );
  }

  ngOnDestroy(): void {
    this._window.removeEventListener('message', this._handleMessage);
  }

  getIframeSrc(): string {
    const html = `
      <html>
        <body onload="document.challenge.submit()">
          <form method="post" name="challenge" action="${this._3dsData().url}">
            <input type="hidden" name="creq" value="${this._3dsData().creq}" />
          </form>
        </body>
      </html>
    `;

    return 'data:text/html;base64,' + btoa(html);
  }
}
